import React, { PropTypes, Component } from 'react';
import Rating from './Rating';
import Reviews from './Reviews';
import Carousel from './Carousel';
import Notification from './Notification';
import Chartreview from './Chartreview';
import { connectToStores } from 'fluxible/addons';
import { createReview } from '../actions/LoginServiceCreator';

class ServiceEntity extends Component {
  static propTypes = {
    entities: PropTypes.object.isRequired
  }

  static defaultProps = {
    entities: {}
  }

  static contextTypes = {
    executeAction: React.PropTypes.func
  }

  render() {
    const service_entity = this.props.data;
    const service = this.props.data.service[0];
    var reply_reviews = this.props.data.service[1];
    var trending = this.props.data.trending;
    return (
      <div className="container-fluid" style={ { "padding": "0em" } }>
        <div className="row-fluid">
          <div className="col-md-12 container-content">
            <div className="category-back-btn">
              <a href="/" style={ { "text-decoration": "none", "color": "black" } }><span className="category-all"><i className="icon-angle-left"></i>Back to all</span></a>
            </div>
          </div>
        </div>
        <div className="row-fluid clearfix">
          <div className="col-md-2" style={ { "padding": "0px" } }>
            <div className="item">
              <div className="item-count">Ranked #
                { this.props.data.service[2] }
              </div>
              <div className="item-matchcount">among all Restaurants</div>
            </div>
            <div className="item-rating item">
              <div className="item-count">
                { service[0].rating.toFixed(1) }
              </div>
              <Rating entities={ service[0] } />
            </div>
            <div className="item-review item">
              <div className="entity-container-reviewsbtn item-entity-rating" style={ { "margin": "0px auto", "width": "10.5em" } }>
                { service[0].total_count } User reviews</div>
            </div>
          </div>
          <div className="col-md-5" style={ { "padding": "0px" } }>
            <div className="item-container">
              <div style={ { "padding-left": "3em" } }>
                <div className="item-container-title">
                  { service[0].display_name.replace(/&amp;/g, '&') }
                </div>
              </div>
              <div style={ { "padding-left": "3em" } }>
                <div className="item-container-desc"></div>
                <div style={ { "float": "left" } } className="readmore"></div>
              </div>
              <div className="tag-container">
                <i className="sprite-red sprite-Tag-Copy" style={ { "margin-top": "0.5em" } }></i>
                { service[0].cuisines.map(function(cuisineItem) {
                    return (<div className="tagnames">
                              { cuisineItem }
                            </div>);
                  }) }
              </div>
              <div style={ { "position": "relative", "width": "100%", "float": "left", "padding-left": "3em" } }>
                <div style={ { "position": "relative", "float": "left" } }>
                  <div className="item-btn submit-review" onClick={ this.focusToReview.bind(this, this.props.logindata.logged_in) }>Submit a reviews</div>
                  <div className="item-btn ask-btn">Ask friends</div>
                </div>
              </div>
              <div className="link-container">
                <div className="websitelink-container"><i className="sprite-red sprite-noun_link_182908"></i></div>
                <div className="sociallink-container">
                  <div className="fshare"></div>
                  <div className="tweet"></div>
                  <div className="inshare"></div>
                  <div className="email"></div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-5" style={ { "padding": "0px", "position": "relative", "overflow": "hidden" } }>
            <Carousel entities={ service[0] } />
          </div>
        </div>
        <div className="row-fluid clearfix" style={ { "background-color": "#f0f0f0" } }>
          <div className="col-md-12 review-leftcontainer">
            <div>
              <Chartreview entities={ service } />
              <div style={ { "padding": "5em", "padding-top": "0em" } }>
                <div id="reviewContainer">
                  <Reviews entities={ service_entity } />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      );
  }
  trending() {
    var trendingheight = $('#Trending').children().size();
    $('#Trending').css("height", +trendingheight * 190 + "px");
    var trendingheight = trendingheight * 190;
    var trendingposition = $('#Trending').css("margin-top");
    trendingposition = trendingposition.slice(0, -2);
    if (trendingposition <= -570) {
      trendingposition -= 570;
      if (trendingposition >= -trendingheight) {
        $('#Trending').animate({
          "margin-top": +trendingposition + "px"
        }, "slow");
      }
    } else {
      $('#Trending').animate({
        "margin-top": "-570px"
      }, "slow");
    }
  }


  focusToReview(loggedin) {
    if (loggedin != 0) {
      $('html, body').animate({
        scrollTop: $("#text-review").offset().top - 120
      }, 2000);
      $('#text-review').focus();
    }
    else
      window.location.href = '/login';
  }
}
ServiceEntity.defaultProps = {
  logindata: {}
};

ServiceEntity = connectToStores(ServiceEntity, ['LoginStore'], (stores, props) => {
  return {
    logindata: stores.LoginStore.get()
  };

});
module.exports = ServiceEntity;


// WEBPACK FOOTER //
// ./src/components/ServiceEntity.js